import Figura from './Figura';
import { proceso } from '../data/contenido';
import { fotosProceso } from '../data/fotos';

export default function Proceso() {
  return (
    <section className="proceso" id="proceso">
      <div className="envoltura">
        <div className="proceso__grilla">
          <div className="proceso__cabeza">
            <div className="cabecera" data-reveal="">
              <p className="rotulo">Flores prensadas</p>
              <h2 className="titulo">{proceso.titulo}</h2>
            </div>
            <p data-reveal="" style={{ '--retraso': '120ms' }}>
              {proceso.bajada}
            </p>
          </div>

          <div className="proceso__pasos">
            {proceso.pasos.map((paso, i) => (
              <article className="paso" key={paso.numero}>
                <Figura className="paso__figura" foto={fotosProceso[i]} />
                <div className="paso__texto" data-reveal="" style={{ '--retraso': '120ms' }}>
                  <p className="paso__numero">{paso.numero}</p>
                  <h3 className="paso__titulo">{paso.titulo}</h3>
                  <p>{paso.texto}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
